module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/streaming-a6e1f3d34170575d19347d455775082d.svg";